<template>
    <v-dialog v-model="isShowDialog" :hide-overlay="isHideOverlay" persistent width="300">
        <v-card color="accent" dark>
            <v-card-text>
                {{ progressMessage }}
                <v-progress-linear indeterminate color="white" class="mb-0" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'ProgressDialog',
})
export default class ProgressDialog extends Vue {
    @Prop({ default: '' }) message: string;
    @Prop({ default: false }) isShow: boolean;
    @Prop({ default: false }) hideOverlay: boolean;

    get isHideOverlay(): boolean {
        return this.hideOverlay;
    }
    get progressMessage(): string {
        return this.message;
    }
    get isShowDialog(): boolean {
        return this.isShow;
    }
}
</script>
